import React, { useState } from 'react';
import './FAQSection.css'
import logo from './media/pixelated.png';

const FAQSection = ({ faqData }) => {
    const [activeIndex, setActiveIndex] = useState(null);

    const toggleAccordion = (index) => {
        if (activeIndex === index) {
            setActiveIndex(null);
        } else {
            setActiveIndex(index);
        }
    };

    return (
        <div className="faq-section">
            <h2>Frequently Asked Questions ?</h2>
            <div className="faq-list">
                {faqData.map((faq, index) => (
                    <div className="faq-item" key={index}>
                        <div className='ques'>
                            <img src={logo} />
                            <p
                                className={`faq-question ${activeIndex === index ? 'active' : ''}`}
                                onClick={() => toggleAccordion(index)}
                            >
                                {faq.question}
                            </p>
                        </div>
                        {activeIndex === index && (
                            <p className="faq-answer">{faq.answer}
                            </p>
                        )}
                    </div>
                ))}
            </div>
        </div>
    );
};

export default FAQSection;
